/**
 * Resolve o `?next=` que login e cadastro carregam para devolver a pessoa à
 * ação que ela tentou fazer como convidada (plano de autenticação v2, J1).
 *
 * Só caminho interno passa: um valor absoluto (`https://…`) ou protocolo-relativo
 * (`//…`) viraria open redirect — a página de login mandando para um site de
 * terceiro depois de digitar a senha é exatamente o cenário de phishing que esse
 * parâmetro cria quando não é validado.
 */
export function resolveNextPath(raw: string | null | undefined, fallback = '/'): string {
  if (!raw) return fallback;
  if (!raw.startsWith('/') || raw.startsWith('//')) return fallback;

  return raw;
}

/** Anexa o `next` atual a um caminho de auth, preservando a intenção na troca de tela. */
export function withNextParam(path: string, next: string | null | undefined): string {
  if (!next) return path;

  return `${path}?next=${encodeURIComponent(next)}`;
}
